import { useEffect, useState } from 'react';
import s from './SearchBar.module.scss';
import { ReactComponent as SearchIcon } from '../../Icons/Search.svg';
import { clsx } from '../../utils';

const SearchBar = ({
  isAnimated = false,
  backgroundColor,
  iconColor,
  placeholderColor,
  animatedTextColor = '#fff',
  animatedWordColor,
  readOnly,
  inputRef,
  placeholder = '',
  onChange,
  onClick,
}) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [animationKey, setAnimationKey] = useState(0);

  const words = [
    'CBC',
    'CUE',
    'Liver Function Test',
    'Lipid Profile',
    'Thyroid Profile',
    'HbA1c',
    'Vitamin B12',
    'Vitamin D3',
  ];

  function cycle() {
    setCurrentWordIndex((prev) => (prev + 1) % words.length);
    setAnimationKey((prev) => prev + 1);
  }

  useEffect(() => {
    if (!isAnimated) return;
    const interval = setInterval(cycle, 2000);
    return () => clearInterval(interval);
  }, [isAnimated]);

  return (
    <div
      className={clsx(s.root)}
      style={{ backgroundColor, cursor: isAnimated ? 'pointer' : '' }}
      onClick={onClick}
    >
      <SearchIcon className={s.icon} color={iconColor} />

      <div className={s.inputWrapper}>
        <label
          className={clsx(
            s.placeholder,
            placeholderColor === '#fff' && s.light
          )}
          style={{ cursor: 'pointer' }}
        >
          {isAnimated && (
            <>
              <span style={{ color: animatedTextColor }}>
                Search & Book &nbsp;
              </span>
              <span
                key={animationKey}
                className={s.word}
                style={animatedWordColor ? { color: animatedWordColor } : {}}
              >
                '{words[currentWordIndex]}'
              </span>
            </>
          )}
        </label>

        {!isAnimated && (
          <input
            ref={inputRef}
            type="text"
            className={clsx(
              s.input,
              placeholderColor === '#fff' ? s.inputLight : s.inputDark
            )}
            style={{
              height: '100%',
              '--placeholder-color': placeholderColor || '#fff',
            }}
            readOnly={readOnly}
            placeholder={placeholder}
            onChange={(e) => {
              if (onChange && onChange instanceof Function) {
                onChange(e.target.value);
              }
            }}
          />
        )}
      </div>
    </div>
  );
};

export default SearchBar;
